import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import style from './HealthAdd.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import { styled } from '@mui/material/styles';
import LinearProgress, {linearProgressClasses,} from '@mui/material/LinearProgress';
import URL from "../../../../../constants/url";
import SurveyMain from '../../../../../components/comsurvey/SurveyMain';
import SurveyListNormal from '../../../../../components/comsurvey/SurveyListNormal';
import ToastPopup from '../../../../../components/comm/ToastPopup';
import Modal from '../../../../../components/comm/Modal';


import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';

import data_health from './data_health.json';


//상위 스텝 바 
const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200],
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: '#1a90ff',
    },
}));

const HealthWrite = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const [step, setStep] = useState(location.state?.step || 1);
    const [selectedValues, setSelectedValues] = useState(location.state?.selectedValues || {}); //라우터로 받아온 제출 리스트
    const [toast, setToast] = useState(false);


    const survey_data = data_health[0];
    const outline = survey_data.outline;
    const surveyList = survey_data.surveyList;
    const totalSteps = surveyList.length;  // 설문 항목 개수

    const handleChange = (e, value) => {
        const currentSurvey = surveyList[step - 1];
        const name = currentSurvey.name;

        const selectedOption = currentSurvey.options.find(opt => opt.value === value);
        const markVal = selectedOption?.markVal ?? null;

        setSelectedValues(prev => ({
            ...prev,
            [name]: {
                value: e.target.type === 'checkbox'
                    ? (prev[name]?.value ? toggleCheckboxValue(prev[name].value, value) : [value])
                    : value,
                markVal: markVal
            }
        }));
    };

    const toggleCheckboxValue = (arr, value) => {
        if (arr.includes(value)) {
            return arr.filter(v => v !== value);
        } else {
            return [...arr, value];
        }
    };

    const handleSubmit = async () => {
        const jToken = localStorage.getItem('jToken');
        const questionKey = surveyList[step - 1].name;
        const answer = selectedValues[questionKey];

        const reqBody = {
            usrSrveyRsltId: location.state?.usrSrveyRsltId,
            qesitmNo: step,
            answrArry: Array.isArray(answer?.value) ? answer.value : [answer?.value],
            markVal: answer?.markVal ?? -1
        };

        try {
            const res = await axiosApi.post(
                "/homecare/srvey/saveUsrSrveySbmt",
                reqBody,
                { headers: { Authorization: jToken } }
            );
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                handleResultSave();
            } else {
                alert(res.data.resultMessage);
            }
        } catch (err) {
            console.error("저장 중 오류:", err);
        }
    };

    
    //설문 결과 저장
    const handleResultSave = async () => {
        const url = "/homecare/srvey/updateUsrSrveyRslt"
        const loginUser = JSON.parse(sessionStorage.getItem("loginUser"));
        const totalValue =
        surveyList.reduce((acc, item) => {
            const val = selectedValues[item.name]?.markVal ?? 0;
            return acc + val;
        }, 0);

        const jToken = localStorage.getItem('jToken');
        const reqBody = {
            srveyMngId: survey_data.outline.srveyMngId,
            usrInfoId: loginUser.usrInfoId,
            lastMarkVal: totalValue,
            usrSrveyRsltId: location.state?.usrSrveyRsltId
        };
        const reqOptions = {
            headers: {
                Authorization: jToken,
            }
        };
        try {
            const res = await axiosApi.post(url, reqBody, reqOptions);
            console.log(res);
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setToast(true);
                setTimeout(() => {
                    navigate(-1);
                }, 1200);
            } else {
                alert(res.data.resultMessage);
            }
        } catch (err) {
            console.error("기록 제출 중 오류: ", err);
        }
    };

    
    return (
        <>
            <HeadSub title={outline.title} onBack={() => navigate(-1)}/>
 
            <div id="sub-content" data-layout="white">
                <div className="inner-wrap">
                <div className={style['top-title-box']}>
                    <p>{location.state?.date}</p>
                </div>
                    {/* Progress Bar */}
                    {step >= 1 && step <= totalSteps && (
                        <div className={style["progress-box"]}>
                            <p className={style["progress-count"]}>
                                <span>{step}</span>/<span>{totalSteps}</span>
                            </p>

                            <BorderLinearProgress
                                variant="determinate"
                                value={(step / totalSteps) * 100}
                                className={style['border-linear-progress']}
                            />
                        </div>
                    )} 
                    <SurveyListNormal
                        surveyData={surveyList[step - 1]}
                        selectedValue={
                            selectedValues[surveyList[step - 1].name]?.value
                            || (surveyList[step - 1].type === 'multi' ? [] : '')
                        }
                        onChange={handleChange}
                        step={step}
                    />
                
                    {/* 하단 수정 버튼 영역 :: S */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">

                            <div className="btn-layout" data-btn-num="2">
                                <button
                                        className="btn"
                                        data-btn-type="outline-main"
                                        data-btn-size="lg"
                                        onClick={() => navigate(-1)}
                                        disabled={step === 0}
                                    >
                                        <span>뒤로</span>
                                    </button>
                                <button
                                    className="btn"
                                    data-btn-type="fill-main"
                                    data-btn-size="lg"
                                    onClick={handleSubmit}
                                    disabled={
                                        step >= 1 &&
                                        step <= totalSteps &&
                                        (
                                            surveyList[step - 1].type === 'multi'
                                            ? !selectedValues[surveyList[step - 1].name] || selectedValues[surveyList[step - 1].name].length === 0
                                            : !selectedValues[surveyList[step - 1].name]
                                            || selectedValues[surveyList[step - 1].name].markVal === -1
                                        )
                                    }
                                >
                                    <span>수정</span>
                                </button>
                            </div>
                             
                        </div>
                    </div>               
                    {/* 하단 다음 버튼 영역 :: E */} 

                    {toast && (
                        <ToastPopup
                        setToast={setToast}
                        message={'수정 완료'}
                        position="center"
                        opacity="90"
                        />
                    )}            
                </div>
            </div>   

        </>
    );
};

export default HealthWrite;
